export const terms = {
    searchFilterAdjust: 'Please adjust your search filters to find agents you\'re looking for',
    agentMovement: 'Agent Movement',
    last60Days: 'Last 60 Days',
    last90Days: 'Last 90 Days',
    last180Days: 'Last 180 Days',
    last365Days: 'Last 365 Days',
};

export const filterIds = {
    period: 'agent-movement-period-dropdown',
    menu: 'agent-movement-period-menu',
    metrics: 'agent-movement-metrics-dropdown',
    last365: 'last-365-days-item',
};

export const filterValues = {
    last365Days: 'Last365Days'
};
